import { HttpParameterCodec } from '@angular/common/http';

/**
 * Provides encoding and decoding of URL parameter and query-string values.
 *
 * Serializes and parses URL parameter keys and values to encode and decode them.
 * If you pass URL query parameters without encoding,
 * the query parameters can be misinterpreted at the receiving end.
 *
 */
export class BydHttpUrlEncodingCodec implements HttpParameterCodec {
  /**
   * Encodes a key name for a URL parameter or query-string.
   *
   * @param key The key name.
   * @returns The encoded key name.
   */
  encodeKey(key: string): string {
    return encodeURIComponent(key);
  }

  /**
   * Encodes the value of a URL parameter or query-string.
   *
   * @param value The value.
   * @returns The encoded value.
   */
  encodeValue(value: string): string {
    return encodeURIComponent(value);
  }

  /**
   * Decodes an encoded URL parameter or query-string key.
   *
   * @param key The encoded key name.
   * @returns The decoded key name.
   */
  decodeKey(key: string): string {
    return decodeURIComponent(key);
  }

  /**
   * Decodes an encoded URL parameter or query-string value.
   *
   * @param value The encoded value.
   * @returns The decoded value.
   */
  decodeValue(value: string): string {
    return decodeURIComponent(value);
  }
}
